var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!!_vm.syncHotels.length)?_c('div',{staticClass:"post-filter-wrapper"},[_vm._t("default"),_vm._v(" "),(_vm.loadingState === "loading")?_c('div',{staticClass:"post-filter-wrapper__blocking"}):_vm._e()],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }